import constants from "@/constants/constants.js";
import moment from "moment";

const formatTitle = (str: string | undefined) => {
  if(!str) {
    return str;
  }
  return convertToTitleCase(str.replaceAll('_', ' '));
}

const convertToTitleCase = (str: string) => {
  return str.replaceAll(/\w\S*/g, (txt: string) => {
    return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
  });
}

const getLocalStorage = (key: string) => {
  return localStorage.getItem(key);
}

const setLocalStorage = (key: string, value: string) => {
  localStorage.setItem(key, value);
}

const removeLocalStorage = (key: string) => {
  localStorage.removeItem(key);
}

const proModeActive = () => {
  return getLocalStorage('proMode') === 'yes' ||
    import.meta.env.VITE_PRO_MODE === "yes";
}

const carrierSecretKey = (carrierName: string) => `${constants.SecretPrefix}${carrierName}`;

const countLength = (object: any) => {
  if (object === null || object === undefined) {
    return 0;
  }
  if (Array.isArray(object)) {
    return object.length;
  }
  if (typeof object === 'string') {
    return object.length;
  }
  return Object.keys(object).length;
}

const getCarrierName = (carrier: string) => carrier.toLowerCase().replaceAll(/\s/g, '_');

const formatDate = (date: string) => {
  return moment(date).fromNow();
}

export {
  convertToTitleCase,
  getLocalStorage,
  proModeActive,
  setLocalStorage,
  countLength,
  removeLocalStorage,
  formatTitle,
  getCarrierName,
  carrierSecretKey,
  formatDate  
};
